'use client';
import { createPreset } from "../createPreset.js";
import { caption2ClassNames, useCaption2Styles } from "./useCaption2Styles.styles.js";
/**
 * Text preset component for the Caption2 typography variant
 */ export const Caption2 = createPreset({
    useStyles: useCaption2Styles,
    className: caption2ClassNames.root,
    displayName: 'Caption2'
});
